import httpDriver from 'app/utils/httpDriver';
import { TMutation, TQuery } from 'app/Requests/types';
import { apiRoutes } from 'archive/utils/apiRoutes';
import { checkTranslated } from 'app/utils/helpers';
import { _t } from 'app/utils/i18n';

//tags
export const trashTags = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.trashTags, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const restoreTags = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.restoreTags, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const deleteTags = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteTags, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};

//categories
export const trashCategories = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.trashCategories, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const addCategory = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.addCategory, body);
  return data;
};
export const editCategory = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.editCategory, body);
  return data;
};

export const restoreCategories = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.restoreCategories, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const deleteCategories = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteCategories, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};
//Groups
export const trashGroups = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.trashGroups, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const addGroup = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.addGroup, body);
  return data;
};
export const updateGroup = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.updateGroup, body);
  return data;
};

export const restoreGroups = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.restoreGroups, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const deleteGroups = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteGroups, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};

export const updateReportVersions = async ({
  id,
  itemId,
  country_id,
  classification_id,

  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.updateReportVersions, {
    item_id: +id,
    version_id: +itemId,
    classification_id: +classification_id,
    country_id: +country_id,
  });
  return { ...data, successMessage };
};
export const cloneReportVersions = async ({
  id,
  itemId,
  country_id,
  classification_id,
  name,
  createdDate,
  url,
  cloneAndReplace,
  successMessage,
  files_count,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.cloneReportVersions, {
    item_id: +id,
    version_id: +itemId,
    classification_id: +classification_id,
    country_id: +country_id,
    clone_and_replace: cloneAndReplace,
    created_date: createdDate,
    name,
    url,
    files_count,
  });
  return { ...data, successMessage };
};
//items

export const getItemsPriority = async (): Promise<any> => {
  const { data } = await httpDriver.post('settings/priorities/all');

  return (
    data?.payload?.records.map((opt: any) => {
      return { value: opt.ID, label: checkTranslated(opt?.name, opt?.name_ar) };
    }) || []
  );
};

export const getItemsFrequency = async (): Promise<any> => {
  const { data } = await httpDriver.post('settings/frequencies/all');

  return (
    data?.payload?.records.map((opt: any) => {
      return { value: opt.ID, label: checkTranslated(opt?.name, opt?.name_ar) };
    }) || []
  );
};

export const trashItems = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.trashItems, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const restoreItems = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.restoreItems, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const deleteItems = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteItems, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};
export const getItemsDetails = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.itemsDetails, {
    item_id: queryKey[1],
  });
  return data.payload?.records;
};
export const getItemsSentiments = async (): Promise<any> => {
  const { data } = await httpDriver.post('settings/classifications/all');

  return (
    data?.payload?.records.map((opt: any) => {
      return {
        value: opt.ID,
        label: _t(`hashtags:${opt.name?.toLowerCase()}`),
      };
    }) || []
  );
};
export const trashItem = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.trashItem, { ids: [id] });
  return { ...data, successMessage };
};
export const deleteItem = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteItem, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};
export const restoreItem = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.restoreItem, { ids: [id] });
  return { ...data, successMessage };
};
export const followAction = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.followAction, {
    item_id: +id,
  });
  return { ...data, successMessage };
};
export const unFollowAction = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.unFollowAction, {
    item_id: +id,
  });
  return { ...data, successMessage };
};
export const addNewReport = async ({
  id,
  name,
  country_id,
  classification_id,
  url,
  files_count,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.addNewReport, {
    item_id: +id,
    name: name,
    classification_id: +classification_id,
    country_id: +country_id,
    url: url,
    files_count,
  });
  return { ...data, successMessage };
};
export const addItem = async ({ body }: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.addItem, {
    ...body,
  });
  return { ...data };
};

export const showItemData = async ({ id }: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.itemsDetails, {
    item_id: id,
  });
  return data.payload?.records;
};
export const getPreSignedUrl = async ({
  url,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.preSignedUrl, {
    url: url,
  });
  return data;
};

export const editItem = async ({ body }: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.editItem, {
    ...body,
  });
  return { ...data };
};
